import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
import { getResizedImageUrl } from '../../common/utils/get-resized-image-url';
export const isChannelCard = card => card.type === VIDEO_CARD_TYPES.CHANNEL;
export const isVideoCard = card => card.type === VIDEO_CARD_TYPES.VIDEO || card.type === VIDEO_CARD_TYPES.RECENT_VIDEO;
const shouldPlayInWidget = (videoCard, channelId) => isVideoCard(videoCard) && channelId === videoCard.actionListId;
const prepareCard = _ref => {
  let {
    videoCard,
    thumbnailSize,
    imageHost
  } = _ref;
  return {
    ...videoCard,
    thumbnailUrl: getResizedImageUrl({
      url: videoCard.thumbnailUrl,
      width: thumbnailSize,
      height: thumbnailSize,
      params: {
        lg: 1
      },
      imageHost
    })
  };
};
export const prepareVideoCards = _ref2 => {
  let {
    videoCards,
    channelId,
    thumbnailSize,
    imageHost
  } = _ref2;
  return videoCards.map(videoCard => {
    const cardWithUrl = {
      ...videoCard,
      url: shouldPlayInWidget(videoCard, channelId) ? null : videoCard.url
    };
    return prepareCard({
      videoCard: cardWithUrl,
      thumbnailSize,
      imageHost
    });
  });
};

// NOTE: when video card opened in embed it always leads to user's website
export const prepareEmbedVideoCards = _ref3 => {
  let {
    videoCards,
    thumbnailSize,
    imageHost
  } = _ref3;
  return videoCards.map(videoCard => prepareCard({
    videoCard,
    thumbnailSize,
    imageHost
  }));
};
//# sourceMappingURL=video-cards.js.map